<div class="container-fluid px-4">
  <div class="container-fluid container-shadow">
    <div class="pt-4"></div>
    <h2>
      <small class="float-right">
        <small>
          <small>
            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="loading" (click)="loadFaxes()">
              <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loading }"></i>
            </button>
          </small>
        </small>
      </small>
      Faxes
    </h2>
    <div class="py-2"></div>
    <div class="card-deck">
      <div class="card">
        <h3 class="card-header">Recently Sent</h3>
        <div class="card-body">
          <div class="py-5 my-5 text-center" *ngIf="loading">
            <i class="fas fa-spinner fa-fw fa-pulse fa-5x"></i>
          </div>
          <table *ngIf="!loading" class="table table-striped">
            <thead>
              <tr>
                <th></th>
                <th>From</th>
                <th>Num. Pages</th>
                <th>Status</th>
                <th>Received</th>
                <th>Total Cost</th>
                <th>Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let fax of incomingFaxes">
                <td>
                  <a href="#" (click)="$event.preventDefault(); viewFax(fax.id, faxes_show)">View</a>
                </td>
                <td>{{ fax.from_number }}</td>
                <td>{{ fax.num_pages }}</td>
                <td>{{ fax.from_number }}</td>
                <td>
                  <app-fax-status [status]="fax.status" [statusInfo]="fax.status_str"></app-fax-status>
                </td>
                <td>{{ fax.fax_date_str }}</td>
                <td>{{ fax.cost || 0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                <td>{{ fax.fax_test }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card">
        <h3 class="card-header">Recently Received</h3>
        <div class="card-body">
          <div class="py-5 my-5 text-center" *ngIf="loading">
            <i class="fas fa-spinner fa-fw fa-pulse fa-5x"></i>
          </div>
          <table *ngIf="!loading" class="table table-striped">
            <thead>
              <tr>
                <th></th>
                <th>From</th>
                <th>Num. Pages</th>
                <th>Status</th>
                <th>Received</th>
                <th>Total Cost</th>
                <th>Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let fax of outgoingFaxes">
                <td>
                  <a href="#" (click)="$event.preventDefault(); viewFax(fax.id, faxes_show)">View</a>
                </td>
                <td>{{ fax.from_number }}</td>
                <td>{{ fax.num_pages }}</td>
                <td>{{ fax.from_number }}</td>
                <td>
                  <app-fax-status [status]="fax.status" [statusInfo]="fax.status_str"></app-fax-status>
                </td>
                <td>{{ fax.fax_date_str }}</td>
                <td>{{ fax.cost || 0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                <td>{{ fax.fax_test }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="py-5"></div>
  </div>
</div>
<div class="py-5 my-5"></div>
<ng-template #faxes_show>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Fax</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="viewModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <th scope="row">Fax ID</th>
          <td *ngIf="selectedFax">
            <a target="_blank" [href]="'https://www.phaxio.com/viewFax?faxId=' + selectedFax.id">#{{ selectedFax.id }}</a>
          </td>
        </tr>
        <tr>
          <th scope="row">Direction</th>
          <td *ngIf="selectedFax">
            {{ selectedFax.direction_str }}
          </td>
        </tr>
        <tr>
          <th scope="row">Pages</th>
          <td *ngIf="selectedFax">
            {{ selectedFax.num_pages }}
          </td>
        </tr>
        <tr *ngIf="selectedFax">
          <th scope="row">Histories</th>
          <td *ngIf="selectedFax.fax_histories && selectedFax.fax_histories.length > 0">
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Message</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let history of selectedFax.fax_histories">
                  <td>
                    <app-fax-status [status]="history.status" [statusInfo]="history.status_str"></app-fax-status>
                  </td>
                  <td>{{ history.message }}</td>
                  <td>{{ history.fax_date_str }}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td *ngIf="!selectedFax.fax_histories || selectedFax.fax_histories.length < 1">
            <p>No histories for this fax</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
